import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import { authActions, httpRequestsOnSuccessActions } from 'store';
import { newPasswordSchema } from 'validationSchemes';
import { getStorage, removeStorage } from 'utils/storageHelpers';
import { yupResolver } from '@hookform/resolvers/yup';
import { INPUT_PASSWORD_TYPE, INPUT_TEXT_TYPE } from 'utils/constant';
import { inputName } from './data';
import { ROUTES } from 'utils/routeNames';
import { Images } from 'assets/images';
import { useNavigate } from 'react-router-dom';
import { useFindSuccess } from 'hooks/useFindSuccess';
import { LoadingButton } from 'components';
import { NEW_PASSWORD } from 'store/auth';
import { useFindLoad } from 'hooks/useFindLoad';
import { LazyContainer } from 'components/ImageLazy/styled';
import { ImageLazy } from 'components/ImageLazy';
import {
  InputBlock,
  PasswordVisibleIcon,
  StyledInput,
} from 'components/inputs/inputStyles.js';
import {
  CloseIcon,
  CloseIconLink,
  ForgotPasswordBlock,
  ForgotPasswordWrapper,
  Form,
  PageTitle,
  SendButtonContainer,
  ErrorMessage,
} from './styled';

const ChangePassword = () => {
  const navigate = useNavigate();

  const [inputType, setInputType] = useState({
    password: INPUT_PASSWORD_TYPE,
    confirm_password: INPUT_PASSWORD_TYPE,
  });

  const isSuccess = useFindSuccess(NEW_PASSWORD);

  const isLoading = useFindLoad(NEW_PASSWORD);

  const dispatch = useDispatch();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(newPasswordSchema),
  });

  const onSubmit = (data) => {
    const { password, confirm_password } = data;
    dispatch(
      authActions.newPassword({
        new_password: password,
        repeat_password: confirm_password,
        email: getStorage('verify_email'),
      }),
    );
  };

  const togglePasswordVisibility = (type) => {
    setInputType({
      ...inputType,
      [type]:
        inputType[type] === INPUT_PASSWORD_TYPE
          ? INPUT_TEXT_TYPE
          : INPUT_PASSWORD_TYPE,
    });
  };

  useEffect(() => {
    if (isSuccess.length) {
      setTimeout(() => {
        removeStorage('verify_email');
        navigate(ROUTES.LOGIN);
      }, 2500);
    }
  }, [isSuccess.length]);

  useEffect(
    () => () => {
      dispatch(httpRequestsOnSuccessActions.removeSuccess(NEW_PASSWORD));
    },
    [],
  );

  return (
    <ForgotPasswordWrapper>
      <LazyContainer>
        <ImageLazy
          src={Images.loginMainBackground}
          width="100%"
          height="100%"
          hash="LqBE%hJDxWWBX=xaaxa}x^awWYof"
        />
      </LazyContainer>
      <ForgotPasswordBlock>
        <Form onSubmit={handleSubmit(onSubmit)}>
          <PageTitle>Create New Password</PageTitle>
          <CloseIconLink to={ROUTES.LOGIN}>
            <CloseIcon src={Images.closeBlueIcon} />
          </CloseIconLink>
          <InputBlock>
            <StyledInput
              placeholder="New Password"
              type={inputType.password}
              {...register('password')}
              error={errors?.password?.message}
            />
            <PasswordVisibleIcon
              src={
                inputType.password === INPUT_PASSWORD_TYPE
                  ? Images.passwordClosedEye
                  : Images.passwordOpenedEye
              }
              onClick={() => togglePasswordVisibility(inputName.password)}
            />
          </InputBlock>
          <ErrorMessage>{errors.password?.message}</ErrorMessage>
          <InputBlock>
            <StyledInput
              placeholder="Confirm New Password"
              type={inputType.confirm_password}
              {...register('confirm_password')}
              error={errors?.confirm_password?.message}
            />
            <PasswordVisibleIcon
              src={
                inputType.confirm_password === INPUT_PASSWORD_TYPE
                  ? Images.passwordClosedEye
                  : Images.passwordOpenedEye
              }
              onClick={() => togglePasswordVisibility(inputName.confirm_password)}
            />
          </InputBlock>
          <ErrorMessage>{errors.confirm_password?.message}</ErrorMessage>
          <SendButtonContainer>
            <LoadingButton
              width="100%"
              height="54px"
              fs="20px"
              loading={isLoading}
              name="Save"
              type="submit"
            />
          </SendButtonContainer>
        </Form>
      </ForgotPasswordBlock>
    </ForgotPasswordWrapper>
  );
};
export default ChangePassword;
